import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { Discipline } from '../../models/models';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  PrimaryCauseOfFailure,
  PrimaryCauseOfFailureCollection,
} from './primaryCauseOfFailure.types';

const usePrimaryCauseOfFailure = (disciplineId: number) => {
  const discipline = disciplineId === Discipline.Shaft ? Discipline.Structural : disciplineId;
  const getPrimaryCauseOfFailureQuery = useCallback(
    (collection: PrimaryCauseOfFailureCollection) => {
      return collection?.find({ selector: { discipline } });
    },
    [discipline],
  );

  const { result: primaryCauseOfFailureListData } = useRxData<PrimaryCauseOfFailure>(
    RxdbCollectionName.PRIMARY_CAUSE_OF_FAILURE,
    getPrimaryCauseOfFailureQuery,
    { json: true },
  );

  return { primaryCauseOfFailureListData };
};

export default usePrimaryCauseOfFailure;
